<template>
  <div>
    <vs-button color="primary" type="filled" @click="scrap">Scrap</vs-button>
  </div>
</template>

<script>

export default {
  name: "scraping",
  methods: {
    async scrap() {
      const puppeteer = require('puppeteer');

      try {
        const browser = await puppeteer.launch({
          args: ['--no-sandbox', '--disable-setuid-sandbox'],
        });
        const page = await browser.newPage();
        await page.goto('https://lemonspaces.com/properties/search?area=0&guests=0&beds=0&bedrooms=0&bathrooms=0');
        await page.waitForSelector('.rating-div', { timeout: 5000 });

        const body = await page.evaluate(() => {
          return document.querySelector('body').innerHTML;
        });
        console.log(body);

        await browser.close();
      } catch (error) {
        console.log(error);
      }
    },
  }
}
</script>
